import React from "react";
import medicinebanner from "../assets/images/medicin_banner.png";
import "./MedicalEquipments.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Filter from "../layout/Filter";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom"; //Link
import Equipments from "./Equipments";
import Testimonial from "../layout/Home/Testimonial";
import Review from "../layout/Home/Review";
import Faq from "../layout/Home/Faq";
import OrderMedicine from "./OrderMedicine";
import { useState } from "react";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";

const banner = [
  {
    id: 1,
    image: medicinebanner,
  },
  {
    id: 2,
    image: medicinebanner,
  },
  {
    id: 3,
    image: medicinebanner,
  },
];

function Medicine() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header /> 
       <div className="test_bredcum_sec with_background">
             <div className="container-fluid">
                <div className="test_bredcum">
                  <Link to="/">Home</Link>
                  <span>&gt;</span>
                  <span className='name_p'>Order Medicines</span>
                </div> 
              </div> 
          </div>

      <div className="container-fluid">
        <div className="services_filter_caregiver">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              <Filter open={open} setOpen={setOpen} />
            </div>
            <div className="col-xl-9 col-lg-8 col-sm-12 col-12">
              <div className="right_side_header_test">
                <div>
                  <h3>Medicines</h3>
                <div className="filter_btn">
                  <button className="filter_btn" onClick={() => setOpen(true)}>
                    <TuneRoundedIcon />
                  </button>
                </div>
                </div>
                

                <div className="search_bar_test_sec d-block">
                  <div className="main_serach_bar_test">
                    <form className="search-form_test caregiver_sev_box_h">
                      <input
                        type="search"
                        placeholder="Search Products.........."
                        className="search_input"
                      />
                      <button type="submit" className="search_btn">
                        {" "}
                        <SearchIcon />{" "}
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              <div className="caregiver_serv_boxes">
                <div className="row">
                  <OrderMedicine />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonial />

      <Review />

      <Faq />
      <Footer />
    </>
  );
}

export default Medicine;
